// 接口列表
// import config from '@/config'
import http from '@/plugins/wjtools'
// const uniclound = 'https://uniclound.kjhaoyun.com'
// const mockurl = 'https://rap2.17haoyun.cn/app/mock/88/' // eslint-disable-line

// // 验证手机号是否注册|post
// export const verifyRegister = params => http.post('kjhy-account/validate/phoneNumber', params)

// 账号登录|post
export const emailLogin = params => http.post('account/login', params)

// 退出登录|post
export const logout = params => http.post('account/logout', params)

// 系统管理-账号分页
export const accountPage = params => http.post('account/page', params)

// 系统管理-添加账号
export const addAccount = params => http.post('account/add', params)

// 系统管理-编辑账号
export const updateAccount = params => http.post('account/update', params)

// 系统管理-更新账号状态
export const updateAccountStatus = params => http.post('account/updateStatus', params)

// 系统管理-删除账号
export const deleteAccount = params => http.post('account/delete', params)

// 系统管理-角色分页
export const rolePage = params => http.post('role/page', params)

// 系统管理-添加角色
export const addRle = params => http.post('role/add', params)

// 系统管理-编辑角色
export const updateRole = params => http.post('role/update', params)

// 系统管理-菜单列表
export const menuList = params => http.post('menu/list', params)

export const managerMenuTable = params => http.post('menu/table', params)

// 系统管理-添加菜单
export const addMenu = params => http.post('menu/add', params)

// 系统管理-更新菜单
export const updateMenu = params => http.post('menu/update', params)

// API Key 获取
export const getApiKey = params => http.get('sysUserApiKey/get', params)

// API Key 生成
export const generateApiKey = params => http.post('sysUserApiKey/generate', params)

// API Key 重置
export const resetApiKey = params => http.post('sysUserApiKey/reset', params)

// 系统管理-删除菜单
export const deleteMenu = params => http.post('menu/delete', params)

// 系统管理-角色菜单
export const roleMenuList = params => http.post('menu/roleMenuList', params)

// 系统管理-更新角色菜单
export const updateRoleMenu = params => http.post('menu/updateRoleMenu', params)

// 系统管理-角色列表
export const roleList = params => http.post('role/list', params)

// 系统管理-更新账号角色
export const updateAccountRole = params => http.post('role/updateAccountRole', params)

// 系统管理-查询账号绑定状态
export const getUserBindStatus = params => http.post('account/getUserBindStatus', params)

// 系统管理-绑定账号二维码
export const bindQrCode = params => http.post('account/bindQrCode', params)

// 双号合并-H5 确认页预览（匿名：pendingToken + 服务号 OAuth code）
export const mergePreview = params => http.post('account/mergePreview', params)

// 双号合并-确认执行（匿名：会话归属已在 preview 时落 Redis）
export const mergeConfirm = params => http.post('account/mergeConfirm', params)

// 系统管理-兜底合并（登录态，按编号指定 source/target）
export const mergeMiniAccount = params => http.post('account/mergeMiniAccount', params)

// 获取登录二维码
export const loginQrCode = params => http.post('account/loginQrCode', params)

// 获取微信登录状态
export const checkWxLogin = params => http.post('account/checkWxLogin', params)

// 分类管理分页
export const categoryPage = params => http.post('category/page', params)

// 添加分类
export const addCategory = params => http.post('category/add', params)

// 更新分类
export const updateCategory = params => http.post('category/update', params)

// 删除分类
export const deleteCategory = params => http.post('category/delete', params)

// 分类列表
export const categoryList = params => http.post('category/list', params)

// 内容风格分页
export const contentStyleProfilePage = params => http.post('contentStyleProfile/page', params)

// 内容风格列表
export const contentStyleProfileSelect = params => http.post('contentStyleProfile/select', params)

// 添加内容风格
export const addContentStyleProfile = params => http.post('contentStyleProfile/add', params)

// 更新内容风格
export const updateContentStyleProfile = params => http.post('contentStyleProfile/update', params)

// 删除内容风格
export const deleteContentStyleProfile = params => http.post('contentStyleProfile/delete', params)

// Skill 包分页
export const skillPackagePage = params => http.post('portal/skill-package/page', params)

// Skill 包下拉(节点表单用)
export const skillPackageSelect = params => http.post('portal/skill-package/select', params)

// 更新 Skill 包(改名/说明/状态)
export const skillPackageUpdate = params => http.post('portal/skill-package/update', params)

// 删除 Skill 包
export const skillPackageDelete = params => http.post('portal/skill-package/delete', params)

// 小红书样式库列表
export const xhsStyleList = () => http.get('xhs/styles/list')

// 小红书样式库重新生成
export const xhsStyleRegenerate = () => http.post('xhs/styles/regenerate')

// AI提示词模板分页
export const aiPromptTemplatePage = params => http.post('aiPromptTemplate/page', params)

// AI提示词模板场景列表
export const aiPromptTemplateSceneOptions = params => http.post('aiPromptTemplate/sceneOptions', params)

// AI提示词模板下拉
export const selectAiPromptTemplate = params => http.post('aiPromptTemplate/select', params)

// 添加AI提示词模板
export const addAiPromptTemplate = params => http.post('aiPromptTemplate/add', params)

// 更新AI提示词模板
export const updateAiPromptTemplate = params => http.post('aiPromptTemplate/update', params)

// 删除AI提示词模板
export const deleteAiPromptTemplate = params => http.post('aiPromptTemplate/delete', params)

// 分类移到最前
export const moveCategoryToTop = params => http.post('category/moveToTop', params)

// 工作流分页
export const pipLinePage = params => http.post('pipLine/page', params)

// 公共工作流分页
export const pipLineCommonPage = params => http.post('pipLine/commonPage', params)

// 添加公共工作流
export const addCommonPipLine = params => http.post('pipLine/addCommon', params)

// 更新公共工作流
export const updateCommonPipLine = params => http.post('pipLine/updateCommon', params)

// 复制工作流
export const copyPipLine = params => http.post('pipLine/copy', params)

// 工作流列表
export const pipLineList = params => http.post('pipLine/list', params)

// 添加工作流
export const addPipLine = params => http.post('pipLine/add', params)

// 更新工作流
export const updatePipLine = params => http.post('pipLine/update', params)

// 删除工作流
export const deletePipLine = params => http.post('pipLine/delete', params)

// 工作流移到最前
export const movePipLineToTop = params => http.post('pipLine/moveToTop', params)

// 工作流插件分页
export const pipLinePluginPage = params => http.post('pipLinePlugin/page', params)

// 添加工作流插件
export const addPipLinePlugin = params => http.post('pipLinePlugin/add', params)

// 更新工作流插件
export const updatePipLinePlugin = params => http.post('pipLinePlugin/update', params)

// 工作流插件树
export const rolePluginTree = params => http.post('pipLinePlugin/rolePluginTree', params)

// 更新角色工作流插件
export const rolePluginUpdate = params => http.post('pipLinePlugin/rolePluginUpdate', params)

// 工作流运行时间列表
export const cronList = params => http.post('pipLine/cronList', params)

// 图文内容库分页
export const textContentLibraryPage = params => http.post('textContentLibrary/page', params)

// 加工失败内容计数（图文库「加工失败」页签徽标）
export const textContentLibraryFailedProcessCount = () => http.post('textContentLibrary/failedProcessCount')

// 爬取网页
export const catchWeb = params => http.post('textContentLibrary/catchWeb', params)

// 通用AI自动分类
export const detectAiCategory = params => http.post('aiCategory/detect', params)

// 图文内容库添加内容
export const addTextContentLibrary = params => http.post('textContentLibrary/add', params)

// 上传图片
export const uploadImage = params => http.upload('oss/uploadImage', params)

// 转存外链图片
export const storeImageByUrl = params => http.post('oss/storeByUrl', params)

// 流程编排-插件分组列表
export const getPluginGroup = params => http.post('pipLinePlugin/getPluginGroup', params)

// 工作流流程列表
export const getPipLineItemList = params => http.post('pipLineItem/getPipLineItemList', params)

// 添加流程节点
export const addPipLineItem = params => http.post('pipLineItem/addPipLineItem', params)

// 插入流程节点
export const insertPipLineItem = params => http.post('pipLineItem/insertPipLineItem', params)

// 更新流程节点
export const updatePipLineItem = params => http.post('pipLineItem/updatePipLineItem', params)

// 删除流程节点
export const deletePipLineItem = params => http.post('pipLineItem/deletePipLineItem', params)

// 获取流程节点
export const getPipLineItemDetail = params => http.post('pipLineItem/getPipLineItemDetail', params)

// 公共模型分页
export const aiCommonModelPage = params => http.post('aiModel/commonPage', params)

// 添加公共模型
export const addAiCommonModal = params => http.post('aiModel/addCommonModel', params)

// 编辑模型
export const updateAiModel = params => http.post('aiModel/update', params)

// 删除模型
export const deleteAiModel = params => http.post('aiModel/delete', params)

// 编辑图文内容库
export const updateTextContentLibrary = params => http.post('textContentLibrary/update', params)

// 删除图文内容
export const deleteTextContentLibrary = params => http.post('textContentLibrary/delete', params)

// 打回 AI已处理库 内容到 AI待处理库，交回工作流重新加工
export const rollbackTextContentToPreAiProcess = params => http.post('textContentLibrary/rollbackToPreAiProcess', params)

// 小程序跳转配置(1.49 阅读原文普适化):账号级「我的小程序」注册表,仅公开信息(appid/path)
export const miniProgramConfigList = () => http.get('miniProgramConfig/list')
export const addMiniProgramConfig = params => http.post('miniProgramConfig/add', params)
export const updateMiniProgramConfig = params => http.post('miniProgramConfig/update', params)
export const deleteMiniProgramConfig = params => http.post('miniProgramConfig/delete', params)

// AI模型平台列表
export const aiPlatformList = params => http.post('aiModel/aiPlatformList', params)

// 图文审核库分页
export const textCheckContentLibraryPage = params => http.post('textCheckContentLibrary/page', params)

// 添加图文审核内容
export const addTextCheckContentLibrary = params => http.post('textCheckContentLibrary/add', params)

// AI模型分页
export const aiModelPage = params => http.post('aiModel/page', params)

// AI模型每日用量统计(当前账号;aiModelId为空=全部模型汇总)
export const aiModelUsageStats = params => http.post('aiModel/usageStats', params)

// 公共AI模型每日用量统计(全账号聚合,管理端)
export const aiModelCommonUsageStats = params => http.post('aiModel/commonUsageStats', params)

// 封面库分页
export const coverLibraryPage = params => http.post('coverLibrary/page', params)

// 封面库添加
export const addCoverLibrary = params => http.post('coverLibrary/add', params)

// 封面库编辑
export const updateCoverLibrary = params => http.post('coverLibrary/update', params)

// 封面库删除
export const deleteCoverLibrary = params => http.post('coverLibrary/delete', params)

// 内容配图库
export const contentImageLibraryPage           = params => http.post('contentImageLibrary/page', params)
export const updateContentImageLibraryName      = params => http.post('contentImageLibrary/updateName', params)
export const deleteContentImageLibrary          = params => http.post('contentImageLibrary/delete', params)
export const getContentImageLibrarySetting      = params => http.post('contentImageLibrary/setting/get', params)
export const updateContentImageLibrarySetting   = params => http.post('contentImageLibrary/setting/update', params)
export const batchIngestHistoricalContentImage  = params => http.post('contentImageLibrary/batchIngestHistorical', params)
export const uploadContentImageLibrary          = params => http.upload('contentImageLibrary/upload', params)

// 添加AI模型
export const addAiModel = params => http.post('aiModel/add', params)

// 运行工作流
export const runPipLine = params => http.post('pipLine/run', params)

// 停止工作流
export const stopPipLine = params => http.post('pipLine/stop', params)

// 分发账号分页
export const distributeAccountPage = params => http.post('distributeAccount/page', params)

// 分发平台列表
export const distributePlatformList = params => http.post('distributeAccount/distributePlatformList', params)

// 微信监控账号分页
export const wechatMonitorAccountPage = params => http.post('wechatMonitorAccount/page', params)

// 添加微信监控账号
export const addWechatMonitorAccount = params => http.post('wechatMonitorAccount/add', params)

// 微信监控账号添加二维码
export const wechatMonitorGetQrCode = (params, config) => http.post('wechatMonitorAccount/getQrCode', params, config)

// 微信监控账号二维码检查
export const checkWechatMonitorQrCode = params => http.post('wechatMonitorAccount/checkQrCode', params)

// 微信监控账号登录
export const wechatMonitorLogin = params => http.post('wechatMonitorAccount/login', params)

// 删除微信监控账号
export const deleteWechatMonitorAccount = params => http.post('wechatMonitorAccount/delete', params)

// 工作流日志分页
export const pipLineLogPage = params => http.post('pipLineLog/page', params)

// 获取微信第三方平台授权链接
export const getWechatOpenAuthUrl = params => http.post('wechat/open/api/getAuthUrl', params)

// 获取未读消息数量
export const noReadMessageCount = params => http.post('message/noReadMessageCount', params)

// 获取消息分页
export const messagePage = params => http.post('message/page', params)

// 更新消息读状态
export const updateMessageReadStatusBatch = params => http.post('message/updateReadStatusBatch', params)

// 自媒体账号登录
export const distributePlatformLogin = params => http.post('distributeAccount/platformLogin', params)

// 获取自媒体账号登录二维码
export const distributePlatformLoginCode = params => http.post('distributeAccount/getPlatformLoginCode', params)

// 获取自媒体账号登录状态
export const distributePlatformLoginStatus = params => http.post('distributeAccount/getPlatformLoginStatus', params)

// 创建 sidecar 扫码登录会话(platform: toutiao / xiaohongshu)
export const sidecarLoginSession = params => http.post('distributeAccount/sidecar/loginSession', params)

// 获取 sidecar 扫码登录状态
export const sidecarLoginStatus = params => http.post('distributeAccount/sidecar/loginStatus', params)

// 添加自媒体账号
export const addDistributeAccount = params => http.post('distributeAccount/add', params)

// 编辑自媒体账号
export const updateDistributeAccount = params => http.post('distributeAccount/update', params)

// 删除自媒体账号
export const deleteDistributeAccount = params => http.post('distributeAccount/delete', params)

// 启用/禁用自媒体账号
export const updateDistributeAccountStatus = params => http.post('distributeAccount/updateStatus', params)

// 自媒体账号移到最前
export const moveDistributeAccountToTop = params => http.post('distributeAccount/moveToTop', params)

// 图文分发历史分页
export const textDistributeHistory = params => http.post('textDistributeHistory/page', params)

// 分发历史平台筛选项(当前账号历史中实际出现过的平台)
export const textDistributeHistoryPlatformOptions = params => http.post('textDistributeHistory/platformOptions', params)

// 图文分发记录(Wechatsync插件)
export const recordWechatsyncDistribute = params => http.post('textDistributeHistory/recordWechatsyncDistribute', params)

// 获取封面库列表
export const coverLibraryList = params => http.post('coverLibrary/list', params)

// 图文审核库审核通过
export const textCheckContentAuditSuccess = params => http.post('textCheckContentLibrary/auditSuccess', params)

// 图文审核库审核不通过
export const textCheckContentAuditFail = params => http.post('textCheckContentLibrary/auditFail', params)

// 图文审核库更新内容(不改审核状态,供 XhsNotePreview 保存编辑)
export const updateTextCheckContentLibrary = params => http.post('textCheckContentLibrary/update', params)

// 图文审核库添加
export const addTextCheckContent = params => http.post('textCheckContentLibrary/add', params)

// 公共图文库分页
export const textCommonLibraryPage = params => http.post('textCommonContentLibrary/page', params)

// 公共分类列表
export const commonCategoryList = params => http.post('textCommonContentLibrary/commonCategoryList', params)

// 提取公共图文到审核库
export const copyToTextCheckContentLibrary = params => http.post('textCommonContentLibrary/copyToTextCheckContentLibrary', params)

// 提取公共图文到图文库
export const copyToTextContentLibrary = params => http.post('textCommonContentLibrary/copyToTextContentLibrary', params)

// 获取账号详情
export const accountDetail = params => http.post('account/detail', params)
// 当前登录者是否超级管理员(货架置顶等超管专属开关的显隐依据;失败/未登录按 false 处理)
export const superAdminFlag = () => http.get('account/superAdminFlag')
export const miniBindQrCode = () => http.post('mini/bindQrCode')

// 获取工作流插件任务文档
export const pipLinePluginDoc = params => http.post('pipLinePlugin/pipLinePluginDoc', params)

// 更新工作流文档
export const updatePipLinePluginDoc = params => http.post('pipLinePlugin/updateDoc', params)

// 敏感词分页
export const riskTextPage = params => http.post('riskWord/page', params)

// 添加敏感词
export const addRiskText = params => http.post('riskWord/add', params)

// 编辑敏感词
export const updateRiskText = params => http.post('riskWord/update', params)

// 删除敏感词
export const deleteRiskText = params => http.post('riskWord/delete', params)

// 编辑公共图文
export const updateTextCommonLibrary = params => http.post('textCommonContentLibrary/update', params)

// 删除公共图文
export const deleteTextCommonLibrary = params => http.post('textCommonContentLibrary/delete', params)

// 删除审核库
export const deleteTextCheckLibrary = params => http.post('textCheckContentLibrary/delete', params)

// 工作流历史记录分页
export const sourceDataPage = params => http.post('sourceData/page', params)

// 删除工作流历史记录
export const deleteSourceData = params => http.post('sourceData/delete', params)

// 清空工作流历史记录
export const deleteSourceDataByPipLineId = params => http.post('sourceData/deleteByPipLineId', params)

// 提交提示词
export const storePrompt = params => http.post('aiModel/storePrompt', params)

// 预览AI模型(同步问答验证模型可用性)
export const previewAiModel = params => http.post('aiModel/preview', params, { timeout: 60000 })

// AI 帮忙写 skill:服务端组装 prompt 落库,返回 ticket(走现有 aiWriteStream 流式)
export const storeAiSkillDraftPrompt = params => http.post('portal/loop-skill/ai-draft/store', params)

// ai绘图
export const aiImage = params => http.post('aiModel/aiImage', params, { timeout: 300000 })

// 图文分发账号
export const textAccountSelect = params => http.post('distributeAccount/textAccountSelect', params)

// 图文分发
export const textDistribute = params => http.post('textDistributeHistory/distribute', params)

// ai模型列表
export const aiModelSelect = params => http.post('aiModel/select', params)

export const updateTokenQuotaConfig = params => http.post('aiModel/updateTokenQuotaConfig', params)

// 保存图片算力配置
export const updateImageQuotaConfig = params => http.post('aiModel/updateImageQuotaConfig', params)

// 保存自动分类大模型排序配置
export const updateAutoCategoryConfig = params => http.post('aiModel/updateAutoCategoryConfig', params)

// 保存自动文字模型调用顺序配置
export const updateAutoTextConfig = params => http.post('aiModel/updateAutoTextConfig', params)

// 保存自动图片模型调用顺序配置
export const updateAutoImageConfig = params => http.post('aiModel/updateAutoImageConfig', params)

// api 接入设置
export const pexelsApiList = params => http.post('pexelsApi/list', params)
export const savePexelsApiConfig = params => http.post('pexelsApi/save', params)

export const getApiSetting = params => http.post('apiSetting/get', params)

// 火山AI图片尺寸
export const huoShanSizeList = params => http.post('aiModel/huoShanImageSizeList', params)

// ai剪辑分页
export const aiCutPage = params => http.post('aiCut/page', params)

// 新增AI剪辑
export const addAiCut = params => http.post('aiCut/add', params)

// 获取工作流文档
export const getPipLineDocById = params => http.post('pipLinePlugin/getDocById', params)

// 获取视频
export const getVideo = params => http.post('oss/getVideo', params)

// 角色分发渠道权限树
export const roleDistributePlatformList = params => http.post('distributeAccount/roleDistributePlatformList', params)

// 更新角色分发渠道权限
export const updateRoleDistributePlatform = params => http.post('distributeAccount/updateRoleDistributePlatform', params)

// 退出自媒体账号登陆
export const distributePlatformLogout = params => http.post('distributeAccount/platformLogout', params)

// 账号商品分页
export const distributeAccountProductPage = params => http.post('distributeAccountProduct/page', params)

// 添加账号商品
export const addDistributeAccountProduct = params => http.post('distributeAccountProduct/add', params)

// 编辑账号商品
export const updateDistributeAccountProduct = params => http.post('distributeAccountProduct/update', params)

// 删除账号商品
export const deleteDistributeAccountProduct = params => http.post('distributeAccountProduct/delete', params)

// 账号商品下拉/选择
export const distributeAccountProductSelect = params => http.post('distributeAccountProduct/select', params)

// 资源对话分页
export const resourceChatPage = params => http.post('resourceChat/page', params)

// 添加资源对话
export const resourceChatAdd = params => http.post('resourceChat/add', params)

// 编辑资源对话
export const resourceChatUpdate = params => http.post('resourceChat/update', params)

// 删除资源对话
export const resourceChatDelete = params => http.post('resourceChat/delete', params)

// 资源对话回复日志统计
export const resourceChatReplySummary = params => http.post('resourceChat/replyLogStats/summary', params)
export const resourceChatKeywordRank = params => http.post('resourceChat/replyLogStats/keywordRank', params)
export const resourceChatQuestionRank = params => http.post('resourceChat/replyLogStats/questionRank', params)

// ===== 数据看板 =====
export const dashboardOverview = params => http.post('dashboard/overview', params)
export const dashboardCollect = params => http.post('dashboard/collect', params)
export const dashboardProduction = params => http.post('dashboard/production', params)
export const dashboardDistribute = params => http.post('dashboard/distribute', params)
export const dashboardReadOriginal = params => http.post('dashboard/readOriginal', params)
export const dashboardQuarkSave = params => http.post('dashboard/quarkSave', params)
export const dashboardXianyu = params => http.post('dashboard/xianyu', params)
// 数据看板-流量主收益(微信publisher_adpos_general,T+1,单位分)
export const dashboardAdRevenue = params => http.post('dashboard/adRevenue', params)
// 数据看板-总收入(闲鱼销售额+广告收益+小程序虚拟支付,单位分,无任何来源权限时 data 为 null)
export const dashboardTotalRevenue = params => http.post('dashboard/totalRevenue', params)
// 数据看板-小程序虚拟支付(mini_order 订单口径,实付金额单位元,未扣渠道费)
export const dashboardMiniPay = params => http.post('dashboard/miniPay', params)
// 复用 loopAgent.js 的 fetchLoopStats(/loop-agent/stats,裸 DTO 响应),避免逻辑漂移
export { fetchLoopStats as loopTaskOpsStats } from './loopAgent'

// 微信快捷登录
export const wxCpLogin = params => http.post('account/wxCpLogin', params)


// 今日热榜列表
export const dailyHotList = type => http.get('dailyHot/list/' + type)
// 今日热榜所有列表
export const dailyHotAll = params => http.get('dailyHot/all', params)
export const dailyHotAiCategory = params => http.post('dailyHot/aiCategory', params)
export const getDailyHotSettings = () => http.get('dailyHot/settings')
export const saveDailyHotSettings = params => http.post('dailyHot/settings', params)
// 热榜 AI帮写：后端统一配图 + 标题封面
export const aiHelpWriteEnhance = params => http.post('dailyHot/aiHelpWrite/enhance', params)

// Add Custom Daily Hot Source
export const addDailyHotCustomSource = params => http.post('daily-hot/custom', params)
// Update Custom Daily Hot Source
export const updateDailyHotCustomSource = params => http.post('daily-hot/custom/update', params)
// List Custom Daily Hot Sources
export const listDailyHotCustomSources = () => http.get('daily-hot/custom')
// Delete Custom Daily Hot Source
export const deleteDailyHotCustomSource = (id) => http.del(`daily-hot/custom/delete?id=` + id)

export const updateDailyHotSourceSort = keys => http.post('daily-hot/custom/sort', keys)

export const markdownAiWrite = params => http.post('aiModel/markdownAiWrite', params, { timeout: 180000 })

// 大模型选题节点-预览(不走去重)
export const previewLlmTopic = params => http.post('pipLineItem/previewLlmTopic', params, { timeout: 180000 })

// AI帮写提示词-润色
export const polishPrompt = params => http.post('aiModel/polishPrompt', params, { timeout: 180000 })

// 获取用户提示词
export const getUserPrompt = params => http.get('aiModel/getUserPrompt', params)

// 保存用户提示词
export const saveUserPrompt = params => http.post('aiModel/saveUserPrompt', params)

// 百度图片搜索
export const searchBaiduImages = params => http.post('baidu/images', params)
// Pexels 图片搜索
export const searchPexelsImages = params => http.post('pexels/images', params)

// 智能配图关键词提炼(取光标前段文本 -> 返回关键词)
export const extractSmartImageKeyword = params => http.post('aiCategory/extractSmartImageKeyword', params)

// 收藏夹分页
export const textFavoriteLibraryPage = params => http.post('textFavoriteLibrary/page', params)
// 添加收藏
export const addTextFavoriteLibrary = params => http.post('textFavoriteLibrary/add', params)
// 更新收藏
export const updateTextFavoriteLibrary = params => http.post('textFavoriteLibrary/update', params)
// 删除收藏
export const deleteTextFavoriteLibrary = params => http.post('textFavoriteLibrary/delete', params)

// 变现思路
export const monetizationIdeaPage = params => http.post('monetizationIdea/page', params)
export const monetizationIdeaAdd = params => http.post('monetizationIdea/add', params)
export const monetizationIdeaUpdate = params => http.post('monetizationIdea/update', params)
export const monetizationIdeaUpdateStatus = params => http.post('monetizationIdea/updateStatus', params)
export const monetizationIdeaShelfPinned = params => http.post('monetizationIdea/shelfPinned', params)
export const monetizationIdeaDelete = params => http.post('monetizationIdea/delete', params)
// 预览口径：付费/会员内容 content 仅前 25%（C 端用）
export const monetizationIdeaDetail = params => http.post('monetizationIdea/detail', params)
// 全文口径（登录 + 售卖权限校验：免费/会员/已购）
export const monetizationIdeaDetailFull = params => http.post('monetizationIdea/detailFull', params)
// 管理口径全文（无售卖校验，仅管理端编辑/配置用）
export const monetizationIdeaManageDetail = params => http.post('monetizationIdea/manageDetail', params)

// ============ 微信 Loop 配置（驱动引擎 + 子进程超时，per-account）============
// 获取当前账号 Loop 配置（驱动 + 超时）
export const getLoopModelProfile = () => http.get('portal/loop-model-profile/me')

// 更新当前账号 Loop 配置（driver 五字段 + subprocessTimeoutSeconds 一次提交）
export const updateLoopModelProfile = params => http.put('portal/loop-model-profile/me', params)

// 清除当前账号 Loop 配置（恢复默认：回落 RELAY_BUILTIN + 系统默认超时）
export const clearLoopModelProfile = () => http.del('portal/loop-model-profile/me')

// 供应商目录（admin 维护，账号从中选一个）
export const getLoopDriverProviders = () => http.get('portal/loop-model-profile/providers')

// 测试驱动连通（不落库）
export const testLoopDriver = params => http.post('portal/loop-model-profile/test-driver', params)

// ============ 分发终端（wechatsync 路线C，P2）============
// 终端列表（当前账号私有；在线状态按 lastHeartbeat 60s 内判定）
export const wsTerminalList = () => http.post('wsTerminal/list')
// 新建终端（返回含明文 token）
export const wsTerminalAdd = params => http.post('wsTerminal/add', params)
// 重命名
export const wsTerminalRename = params => http.post('wsTerminal/rename', params)
// 吊销(0)/恢复(1)
export const wsTerminalUpdateStatus = params => http.post('wsTerminal/updateStatus', params)
// 重置 token（旧 token 立即失效）
export const wsTerminalResetToken = params => http.post('wsTerminal/resetToken', params)
// 删除终端
export const wsTerminalDelete = params => http.post('wsTerminal/delete', params)
// 新建终端并签发领取码（一次性、5分钟有效）
export const wsTerminalCreateClaim = params => http.post('wsTerminal/createClaim', params)
// 领取码换终端配置（公开接口，code 即密钥）
export const wsTerminalClaimInfo = params => http.post('wsTerminal/claimInfo', params)

// ============ 夸克网盘 ============
// 账号详情
export const quarkAccountDetail = () => http.get('quark/account/detail')
// 绑定账号(授权码)
export const quarkAccountBind = params => http.post('quark/account/bind', params)
// 发起 OAuth 授权(返回授权链接)
export const quarkAccountAuthUrl = () => http.post('quark/account/authUrl')
// 扫码授权后检测绑定状态
export const quarkAccountAuthCheck = () => http.post('quark/account/authCheck')
// 解绑账号
export const quarkAccountUnbind = () => http.post('quark/account/unbind')
// 自动转存开关
export const quarkAccountToggle = params => http.post('quark/account/toggle', params)
// 自定义转存目录(空=回默认)
export const quarkAccountSaveDir = params => http.post('quark/account/saveDir', params)
// 授权探活
export const quarkAccountProbe = () => http.post('quark/account/probe')
// 转存记录分页
export const quarkSaveLogPage = params => http.post('quark/saveLog/page', params)
// —— 百度网盘账号与统一网盘转存记录 ——
export const baiduAccountDetail = () => http.get('baidu/account/detail')
export const baiduAccountAuthUrl = () => http.get('baidu/account/authUrl')
export const baiduAccountBind = params => http.post('baidu/account/bind', params)
export const baiduAccountUnbind = () => http.post('baidu/account/unbind')
export const baiduAccountToggle = params => http.post('baidu/account/toggle', params)
// 自定义转存目录(空=回默认)
export const baiduAccountSaveDir = params => http.post('baidu/account/saveDir', params)
export const baiduAccountProbe = () => http.post('baidu/account/probe')
export const netdiskSaveLogPage = params => http.post('netdisk/saveLog/page', params)
export const dashboardBaiduSave = params => http.post('dashboard/baiduSave', params)
// —— 网盘转存每日简报 ——
export const netdiskBriefLatest = () => http.get('netdisk/brief/latest')
export const netdiskBriefGenerate = () => http.post('netdisk/brief/generate')
export const netdiskBriefConfigGet = () => http.get('netdisk/brief/config/get')
export const netdiskBriefConfigUpdate = params => http.post('netdisk/brief/config/update', params)
// 飞书表格记录
export const feishuSheetDetail = () => http.get('feishu/sheet/detail')
export const feishuSheetBind = params => http.post('feishu/sheet/bind', params)
export const feishuSheetUnbind = () => http.post('feishu/sheet/unbind')
export const feishuSheetToggle = params => http.post('feishu/sheet/toggle', params)
export const feishuSheetProbe = () => http.post('feishu/sheet/probe')
// 腾讯文档记录
export const tencentDocDetail = () => http.get('tencent/doc/detail')
export const tencentDocBind = params => http.post('tencent/doc/bind', params)
export const tencentDocUnbind = () => http.post('tencent/doc/unbind')
export const tencentDocToggle = params => http.post('tencent/doc/toggle', params)
export const tencentDocProbe = () => http.post('tencent/doc/probe')

// ============ 格伦星球小程序商城商品管理 ============
export const miniProductPage = params => http.post('miniProduct/page', params)
export const miniProductDetail = params => http.post('miniProduct/detail', params)
export const miniProductSave = params => http.post('miniProduct/save', params)
export const miniProductUpdateStatus = params => http.post('miniProduct/updateStatus', params)
export const miniProductDelete = params => http.post('miniProduct/delete', params)

// ============ 格伦星球小程序 AI 小应用管理 ============
export const miniAiAppPage = params => http.post('miniAiApp/page', params)
export const miniAiAppDetail = params => http.post('miniAiApp/detail', params)
export const miniAiAppSave = params => http.post('miniAiApp/save', params)
export const miniAiAppUpdateStatus = params => http.post('miniAiApp/updateStatus', params)
export const miniAiAppDelete = params => http.post('miniAiApp/delete', params)
export const miniAiAppModels = params => http.post('miniAiApp/models', params)

// ============ 格伦星球小程序订单管理（会员运营） ============
export const miniOrderPage = params => http.post('miniOrder/page', params)
export const miniOrderStats = params => http.post('miniOrder/stats', params)
export const miniOrderManualDeliver = params => http.post('miniOrder/manualDeliver', params)
export const miniOrderNotifyConfigGet = params => http.post('miniOrder/notifyConfig/get', params)
export const miniOrderNotifyConfigSave = params => http.post('miniOrder/notifyConfig/save', params)
export const miniOrderNotifyConfigTest = params => http.post('miniOrder/notifyConfig/test', params)

// ============ 格伦星球小程序虚拟支付道具台账 ============
export const miniPayItemPage = params => http.post('miniPayItem/page', params)
export const miniPayItemList = () => http.post('miniPayItem/list')
export const miniPayItemDetail = params => http.post('miniPayItem/detail', params)
export const miniPayItemSave = params => http.post('miniPayItem/save', params)
export const miniPayItemUpdateStatus = params => http.post('miniPayItem/updateStatus', params)
export const miniPayItemDelete = params => http.post('miniPayItem/delete', params)

// ============ 格伦星球小程序商城分类（1.47 动态分类） ============
export const miniCategoryList = () => http.post('miniCategory/list')
export const miniCategorySave = params => http.post('miniCategory/save', params)
export const miniCategoryUpdateStatus = params => http.post('miniCategory/updateStatus', params)
export const miniCategoryDelete = params => http.post('miniCategory/delete', params)

// ============ 账号管理扩展 ============
export const accountUnbindMiniWx = params => http.post('account/unbindMiniWx', params)

